const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'createTestPackage',
    path: `${prefix}/package/createTestPackage`,
    method: 'post',
    params: {
      // autoRenew: 0,
      // basePackageId: '',
      // subBasePackageId: '',
      // buyTime: 0,
      // route: 2,
      // selectedSubFlag: 0,
      // port: 0,
      // website: 0,
      // elasticBandwidth: 0,
      // serviceBandwidth: 0
    },
    desc: '套餐相关-生成试用套餐'
  },
  {
    name: 'checkExistPkg',
    path: `${prefix}/package/getExistPackage`,
    method: 'get',
    params: {
      productType: ''
    },
    desc: '套餐相关-是否已存在相同类型的套餐'
  },
  {
    name: 'paymentDetail',
    path: `${prefix}/order/paymentDetail`,
    method: 'get',
    params: {
      orderIds: ''
    },
    desc: '订单相关-订单支付详情'
  },
  {
    name: 'validateOrderStatus',
    path: `${prefix}/order/validateOrderStatus`,
    method: 'get',
    params: {
      orderId: ''
    },
    desc: '订单相关-校验订单状态是否可支付'
  },
  {
    name: 'paypalPay',
    path: `${prefix}/payment/paypal/pay`,
    method: 'post',
    params: {
      orderIds: []
    },
    desc: '支付相关-Paypal支付'
  },
  {
    name: 'stripePay',
    path: `${prefix}/payment/stripe/pay`,
    method: 'post',
    params: {
      orderIds: []
    },
    desc: '支付相关-Stripe支付'
  },
  {
    name: 'tripleAPay',
    path: `${prefix}/payment/tripleA/pay`,
    method: 'post',
    params: {
      orderIds: []
    },
    desc: '支付相关-TripleA支付'
  },
  {
    name: 'substitutePay',
    path: `${prefix}/payment/substitute/pay`,
    method: 'post',
    params: {
      orderIds: []
    },
    desc: '支付相关-代付'
  },
  {
    name: 'cashPay',
    path: `${prefix}/payment/cash/pay`,
    method: 'post',
    params: {
      orderIds: [],
      password: '',
      validateCode: ''
    },
    desc: '支付相关-现金支付'
  },
  {
    name: 'payCode',
    path: `${prefix}/payment/sendPayCode`,
    method: 'post',
    params: {},
    desc: 'paypal支付获取验证码'
  },
  {
    name: 'substituteCancel',
    path: `${prefix}/payment/substitute/cancel`,
    method: 'post',
    params: {
      orderIds: []
    },
    desc: '支付相关-取消代付'
  },
  {
    name: 'orderSubmit',
    path: `${prefix}/order/orderSubmit`,
    method: 'post',
    params: {},
    desc: '订单相关-订单提交'
  }
]